import { ChangeEvent, useEffect, useState } from "react";

export function useHandleChange(
  value: string | number,
  onChange: Function,
  name: string | number,
  isENNumber?: boolean
) {
  const [inputValue, setInputValue] = useState<string | number>("");

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleChange = (event: ChangeEvent<{ value: string }>) => {
    let value: any = event.target.value;
    if (value && isENNumber) {
      let e = "۰".charCodeAt(0);
      value = value.replace(/[۰-۹]/g, (t: any) => {
        return t.charCodeAt(0) - e;
      });
    }
    setInputValue(value);
    if (onChange) {
      onChange(value, name);
    }
  };

  return { handleChange, inputValue };
}
